import { useMutation } from 'react-query';
import { updateMainQuestionAssessment } from './mainQuestionAssessmentService';
import { CreateMainQuestionAssessment } from './mainQuestionAssessmentTypes';
import { modifyError } from 'utils/error-modifer-utils';
import { toast } from 'react-toastify';

type Props = {
    onError?: (error: Error) => void;
    onSuccess?: () => void;
};

export const useUpdateMainQuestionAssessment = ({
    onSuccess = () => {},
    onError = () => {},
}: Props) => {
    const onErrorModified = (error: any) => {
        const errors = modifyError(error?.response?.data);
        if (errors) {
            for (const err of errors) {
                toast.error(err);
            }
        } else {
            toast.error('Internal error, please contact administrator');
        }

        if (onError) {
            onError(error);
        }
    };
    const mutation = useMutation(
        async (input: { id: string; request: CreateMainQuestionAssessment }) =>
            await updateMainQuestionAssessment(input.id, input.request),
        {
            onSuccess,
            onError: onErrorModified,
        }
    );

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        error: mutation.error,
    };
};
